import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import FilestoreBrowser from './FilestoreBrowser';
import { FilestoreFile } from '../api/filestore';

interface PropertyFileUploadProps {
  onFileSelected: (file: File | FilestoreFile | null) => void;
}

const PropertyFileUpload: React.FC<PropertyFileUploadProps> = ({ onFileSelected }) => {
  const [filestoreBrowserOpen, setFilestoreBrowserOpen] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState<string>('');

  const handleFilestoreFileSelected = (filestoreFile: FilestoreFile) => {
    setSelectedFileName(filestoreFile.original_filename);
    onFileSelected(filestoreFile);
  };

  return (
    <Box sx={{
      left: 10,
      backgroundColor: 'white',
      width: '95%',
      position: 'relative',
      marginTop: '10px',
      padding: '10px',
      borderRadius: '4px',
      border: '1px solid rgba(0, 0, 0, 0.23)',
    }}>
      <Typography variant="body2" sx={{ marginBottom: '8px' }}>
        Property Boundaries (Optional)
      </Typography>
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', marginBottom: '12px' }}>
        Upload shapefiles as ZIP files (.zip) or use KML/GeoJSON
      </Typography>
      
      <Box>
        <Button
          variant="outlined"
          onClick={() => setFilestoreBrowserOpen(true)}
          sx={{
            color: '#00d4ad',
            borderColor: '#00d4ad',
            '&:hover': {
              borderColor: '#00d4ad',
              backgroundColor: 'rgba(0, 212, 173, 0.04)',
            },
          }}
        >
          {selectedFileName || 'Browse My Files'}
        </Button>
        {selectedFileName && (
          <Typography variant="caption" display="block" sx={{ marginTop: '4px', color: 'text.secondary' }}>
            Selected: {selectedFileName}
          </Typography>
        )}
      </Box>

      <FilestoreBrowser
        open={filestoreBrowserOpen}
        onClose={() => setFilestoreBrowserOpen(false)}
        onSelectFile={handleFilestoreFileSelected}
        acceptedFileTypes=".zip,.kml,.geojson,.json"
      />
    </Box>
  );
};

export default PropertyFileUpload;
